// Module
var code = `<div class="alert-selector" style="{{>visibility}}">
    <terceraLabel visible="{{visible}}" text="{{label}}" />

    <div class="alert-selector-right">
        <div class="js-button-info{{#if !visibleInfoBtn}} hidden{{/if}}"
             as-tooltip="infoBtnTooltip">
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#infotool"></use>
            </svg>
        </div>

        <terceraDateSelectorLookup on-timeSelectorLookupOpened="timeLookupOpened"
                                   on-timeSelectorLookupClosed="timeLookupClosed"
                                   expirationTime="{{.expirationTime}}" 
                                   isTodayMinMode="{{true}}"
                                   datePickerButtons="{{datePickerButtons}}"
                                   btnClass="js-lookup-datetime"/>
    </div>
</div>`;
// Exports
export default code;